import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export class CiudUserAuthData {
    id_ciud?: number;
    nombres?: string;
    apellidos?: string;
    tipo_doc_ident?: string;
    num_doc_ident?: string;
    correo?: string;
    telefono?: string;
    password?: string;
    status?: string;
    last_session?: string;
    direccion?: string;
    is_temp_password?: boolean;
    
    constructor(CiudUserAuthData: any) {
        this.id_ciud = CiudUserAuthData.id_ciud ?? 0;
        this.nombres = CiudUserAuthData.nombres ?? '';
        this.apellidos = CiudUserAuthData.apellidos ?? '';
        this.tipo_doc_ident = CiudUserAuthData.tipo_doc_ident ?? '';
        this.num_doc_ident = CiudUserAuthData.num_doc_ident ?? '';
        this.correo = CiudUserAuthData.correo ?? '';
        this.telefono = CiudUserAuthData.telefono ?? '';
        this.password = CiudUserAuthData.password ?? '';
        this.status = CiudUserAuthData.estado ?? '';
        this.last_session = CiudUserAuthData.last_session ?? '';
        this.direccion = CiudUserAuthData.direccion ?? '';
        this.is_temp_password = CiudUserAuthData.is_temp_password ?? false;
    }
}

/* provider solo sirve en clases, no interfaces */
@Injectable({
    providedIn: 'root',
})
export class LoginDataService {
    private dataSubject = new BehaviorSubject<CiudUserAuthData>(new CiudUserAuthData({}));

    constructor() {}

    setData(data: CiudUserAuthData) {
    this.dataSubject.next(data);
    }

    getData() {
    return this.dataSubject.value;
    }

    getDataObservable() {
    return this.dataSubject.asObservable();
    }
}


/* ========== */

export interface userDataGoogle {
    iss?: string;
    azp?: string;
    aud?: string;
    sub?: string;
    email?: string;
    email_verified?: boolean;
    nbf?: number;
    name?: string;
    picture?: string;
    given_name?: string;
    family_name?: string;
    iat?: number;
    exp?: number;
    jti?: string;
}


export interface checkUserActivatedResponseData {
    success: boolean;
    message: string;
    data?: {
        registered: string;
        exists: string;
    };
}